import { render, staticRenderFns } from "./jingdianguanli.vue?vue&type=template&id=e5f58ea0&scoped=true&"
import script from "./jingdianguanli.vue?vue&type=script&lang=js&"
export * from "./jingdianguanli.vue?vue&type=script&lang=js&"
import style0 from "./jingdianguanli.vue?vue&type=style&index=0&id=e5f58ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f58ea0",
  null
  
)

export default component.exports